/**
 * @generated SignedSource<<8f95bd738edc5f10d6b8a7e40c6bc978>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableHeroCarousel_viewer$data = {
  readonly unavailablePdpCarouselRefactor: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_viewer" | "PdpRespSharedHeroCarousel_viewer">;
  readonly " $fragmentType": "PdpRespUnavailableHeroCarousel_viewer";
};
export type PdpRespUnavailableHeroCarousel_viewer$key = {
  readonly " $data"?: PdpRespUnavailableHeroCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableHeroCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableHeroCarousel_viewer",
  "selections": [
    {
      "alias": "unavailablePdpCarouselRefactor",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "unavailablePdpCarouselRefactor"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"unavailablePdpCarouselRefactor\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1e021fbe1213d05b132b9f01f29f8c84";

export default node;
